/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { __extends, __values } from "tslib";
import { AnnotationLayer } from "./AnnotationLayer";
import { CategoryAxisBase } from "./CategoryAxisBase";
import { DependencyProperty } from "igniteui-react-core";
import { CategoryHighlightLayerFrame } from "./CategoryHighlightLayerFrame";
import { Base, Number_$type, typeCast, fromEnum, Point_$type, markType, markDep, runOn } from "igniteui-react-core";
import { XamDataChart } from "./XamDataChart";
import { CategoryHighlightFrameRect } from "./CategoryHighlightFrameRect";
import { List$1 } from "igniteui-react-core";
import { Pool$1 } from "igniteui-react-core";
import { Rectangle } from "igniteui-react-core";
import { PropertyMetadata } from "igniteui-react-core";
import { isNaN_, truncate } from "igniteui-react-core";
import { AnnotationLayerView } from "./AnnotationLayerView";
import { BrushUtil } from "igniteui-react-core";
import { Color } from "igniteui-react-core";
/**
 * @hidden
 */
var CategoryHighlightLayer = /** @class */ /*@__PURE__*/ (function (_super) {
    __extends(CategoryHighlightLayer, _super);
    function CategoryHighlightLayer() {
        var _this = _super.call(this) || this;
        var a = new CategoryHighlightLayerFrame();
        var b = new CategoryHighlightLayerFrame();
        var c = new CategoryHighlightLayerFrame();
        var d = _this.hr / 1000;
        _this.qq = a;
        _this.qp = b;
        _this.qr = c;
        _this.ab = CategoryHighlightLayer.$;
        return _this;
    }
    CategoryHighlightLayer.prototype.get_dc = function () {
        return true;
    };
    CategoryHighlightLayer.prototype.by = function () {
        return new CategoryHighlightLayerView(this);
    };
    CategoryHighlightLayer.prototype.l4 = function (a) {
        _super.prototype.l4.call(this, a);
        this.tc = a;
    };
    Object.defineProperty(CategoryHighlightLayer.prototype, "tf", {
        get: function () {
            return this.c(CategoryHighlightLayer.tm);
        },
        set: function (a) {
            this.h(CategoryHighlightLayer.tm, a);
        },
        enumerable: false,
        configurable: true
    });
    CategoryHighlightLayer.prototype.r2 = function (a, b) {
        if (this.tb == null || this.tb == a) {
            if (!this.at.c) {
                this.mn(b);
            }
        }
    };
    CategoryHighlightLayer.prototype.td = function (a) {
        return a != null && a.co();
    };
    CategoryHighlightLayer.prototype.r5 = function (a, b) {
        var e_1, _a;
        _super.prototype.r5.call(this, a, b);
        var c = a;
        c.g.clear();
        var d = this.te;
        if (isNaN_(this.s8.x) && isNaN_(this.s8.y)) {
            return;
        }
        if (this.tb != null) {
            if (this.td(this.tb)) {
                this.tk(this.tb, c, d);
            }
        }
        else {
            if (typeCast(XamDataChart.$, this.ce) !== null) {
                var e = this.ce;
                try {
                    for (var _b = __values(fromEnum(e.axes)), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var f = _c.value;
                        if (typeCast(CategoryAxisBase.$, f) !== null && this.td(f)) {
                            this.tk(f, c, d);
                        }
                    }
                }
                catch (e_1_1) {
                    e_1 = { error: e_1_1 };
                }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return))
                            _a.call(_b);
                    }
                    finally {
                        if (e_1)
                            throw e_1.error;
                    }
                }
            }
        }
    };
    CategoryHighlightLayer.prototype.tk = function (a, b, c) {
        if (this.b1 == null || this.b1.bv.isEmpty || this.b1.bu.isEmpty) {
            return;
        }
        var d = this.s8.x;
        if (a.cp && isNaN_(d)) {
            d = 0;
        }
        var e = this.pz(this.b1);
        d = e.left + e.width * (d - this.b1.bv.left) / this.b1.bv.width;
        var f = this.s8.y;
        if (!a.cp && isNaN_(f)) {
            f = 0;
        }
        f = e.top + e.height * (f - this.b1.bv.top) / this.b1.bv.height;
        var g = a.me({ $type: Point_$type, x: d, y: f }, c, this.tf);
        this.tj(g, b, a);
    };
    CategoryHighlightLayer.prototype.tj = function (a, b, c) {
        var d = new CategoryHighlightFrameRect();
        d.b = a.left;
        d.e = a.top;
        d.c = a.right;
        d.a = a.bottom;
        d.g = this.sy();
        d.h = this.sz();
        if (d.g == null) {
            d.g = this.tc.cc(c.jv);
        }
        if (d.h == null) {
            d.h = this.tc.cc(c.jv);
        }
        d.d = this.fy;
        d.f = Base.getHashCodeStatic(c);
        if (!a.isEmpty) {
            b.g.addItem(d.f, d);
        }
    };
    CategoryHighlightLayer.prototype.r8 = function (a, b) {
        var e_2, _a;
        _super.prototype.r8.call(this, a, b);
        var c = this.tc.b5;
        var d = a;
        var e = 0;
        try {
            for (var _b = __values(fromEnum(d.g.values)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var f = _c.value;
                var g = c.item(e);
                this.tl(f, g);
                e++;
            }
        }
        catch (e_2_1) {
            e_2 = { error: e_2_1 };
        }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return))
                    _a.call(_b);
            }
            finally {
                if (e_2)
                    throw e_2.error;
            }
        }
        c.count = e;
    };
    CategoryHighlightLayer.prototype.ep = function () {
        return true;
    };
    CategoryHighlightLayer.prototype.tl = function (a, b) {
        if (isNaN_(a.b) || isNaN_(a.e) || isNaN_(a.a) || isNaN_(a.c) || isNaN_(a.d)) {
            b._visibility = 1;
            return;
        }
        this.tc.b7(b, a.b, a.e, a.c - a.b, a.a - a.e);
        b._fill = a.g;
        b._stroke = a.h;
        b.ad = a.d;
        if (this.pi != null) {
            b.ai = this.pi;
        }
        else {
            b.ai = null;
        }
        b.aj = this.pj;
        b.am = this.pl;
        b.al = this.pk;
        b.ak = this.pk;
        b.ac = this.gw;
    };
    CategoryHighlightLayer.prototype.l9 = function (a, b, c, d) {
        _super.prototype.l9.call(this, a, b, c, d);
        switch (b) {
            case CategoryHighlightLayer.$$p[0]:
                this.mn(true);
                break;
            case CategoryHighlightLayer.$$p[1]:
                this.mn(true);
                break;
        }
    };
    CategoryHighlightLayer.$t = markType(CategoryHighlightLayer, 'CategoryHighlightLayer', AnnotationLayer.$);
    CategoryHighlightLayer.tm = DependencyProperty.i("BAndHighlightWidth", Number_$type, CategoryHighlightLayer.$, new PropertyMetadata(2, 10, function (a, b) { return a.raisePropertyChanged("BAndHighlightWidth", b.oldValue, b.newValue); }));
    CategoryHighlightLayer.$$p = markDep(DependencyProperty, PropertyMetadata, CategoryHighlightLayer, 'raisePropertyChanged', ['TargetAxis:tb:tn', [CategoryAxisBase.$, null], 'UseInterpolation:te:to', [0, false]]);
    return CategoryHighlightLayer;
}(AnnotationLayer));
export { CategoryHighlightLayer };
/**
 * @hidden
 */
var CategoryHighlightLayerView = /** @class */ /*@__PURE__*/ (function (_super) {
    __extends(CategoryHighlightLayerView, _super);
    function CategoryHighlightLayerView(a) {
        var _this = _super.call(this, a) || this;
        _this.b4 = null;
        _this.b5 = null;
        _this.b6 = null;
        _this.b4 = a;
        _this.b6 = new List$1(Rectangle.$, 0);
        return _this;
    }
    CategoryHighlightLayerView.prototype.as = function () {
        var _this = this;
        _super.prototype.as.call(this);
        this.b5 = ((function () {
            var $ret = new Pool$1(Rectangle.$);
            $ret.create = runOn(_this, _this.cd);
            $ret.activate = runOn(_this, _this.b8);
            $ret.disactivate = runOn(_this, _this.ca);
            $ret.destroy = runOn(_this, _this.b9);
            return $ret;
        })());
    };
    CategoryHighlightLayerView.prototype.cd = function () {
        var a = new Rectangle();
        a.ab = false;
        this.b6.add(a);
        return a;
    };
    CategoryHighlightLayerView.prototype.b8 = function (a) {
        a._visibility = 0;
    };
    CategoryHighlightLayerView.prototype.ca = function (a) {
        a._visibility = 1;
    };
    CategoryHighlightLayerView.prototype.b9 = function (a) {
        this.b6.remove(a);
    };
    CategoryHighlightLayerView.prototype.cb = function (a) {
        if (a == null) {
            return a;
        }
        return BrushUtil.l(a, 0.1);
    };
    CategoryHighlightLayerView.prototype.cc = function (a) {
        if (a != null) {
            var b = BrushUtil.l(a, 0.3);
            if (b.isGradient) {
                var c = b;
                if (c.gradientStops != null) {
                    for (var d = 0; d < c.gradientStops.length; d++) {
                        var e = c.gradientStops[d];
                        e.color = Color.u(truncate(Math.round((e.color.l) * 0.2)), e.color.o, e.color.n, e.color.m);
                        e.color = e.color;
                    }
                }
            }
            else {
                b.color = Color.u(truncate(Math.round((b.color.l) * 0.2)), b.color.o, b.color.n, b.color.m);
                b.color = b.color;
            }
            return b;
        }
        else {
            return null;
        }
    };
    CategoryHighlightLayerView.prototype.b7 = function (a, b, c, d, e) {
        a._visibility = 0;
        a.n = b;
        a.o = c;
        a.width = d;
        a.height = e;
    };
    CategoryHighlightLayerView.prototype.a6 = function (a, b) {
        _super.prototype.a6.call(this, a, b);
        if (a.d && !b) {
            for (var c = 0; c < this.b6.count; c++) {
                var d = this.b6._inner[c];
                if (d._visibility == 0) {
                    a.w(d);
                }
            }
        }
    };
    CategoryHighlightLayerView.prototype.al = function (a) {
        _super.prototype.al.call(this, a);
        for (var b = 0; b < this.b6.count; b++) {
            this.e.a9.exportRectangleData(a, this.b6._inner[b], "cihRect", ["Main", "CategoryItem"]);
        }
    };
    CategoryHighlightLayerView.$t = markType(CategoryHighlightLayerView, 'CategoryHighlightLayerView', AnnotationLayerView.$);
    return CategoryHighlightLayerView;
}(AnnotationLayerView));
export { CategoryHighlightLayerView };
